module.exports = __webpack_public_path__ + "assets/usa.4d460eba7ba86f6bf02371c443d97cb1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/flags/usa.png
// module id = 90
// module chunks = 0